var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncrease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416 128h-96c-17.7 0-32 14.3-32 32s14.3 32 32 32h27l-90.5 90.5-50.7-50.7c-12.5-12.5-32.8-12.5-45.3 0L32.9 360.9c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L184 300.3l50.7 50.7c12.5 12.5 32.8 12.5 45.3 0L384 246.6V274c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32z",
    fill: "#259160"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncrease);
export default __webpack_public_path__ + "static/media/increase.aa726bbb6fbe16462e937131205833c3.svg";
export { ForwardRef as ReactComponent };